// extracted by mini-css-extract-plugin
export default {"content":"styles_content__a2Hnj","empty_text":"styles_empty_text__4xQRr"};